// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__1JTNM","footer":"ModalFilter_footer__1rVYW"};